// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import {Redirect, Route, Switch} from 'react-router';
import routes from '../../../routes';
import Page from '../../../Page';
import AppleWatchContainer from '../AppleWatch/container/AppleWatchContainer';
import AirpodsContainer from '../Airpods/container/AirpodsContainer';
import IphoneContainer from '../Iphone/container/IphoneContainer';
import SamsungContainer from '../Samsung/container/SamsungContainer';
// import Ps5Container from '../Ps5/container/PlayStationContainer';
import NotFound from '../../error/components/404/404';

import style from '../../new-order/CheckoutStep/components/CheckoutStep.scss';

import type { Location } from '../../../router';
import type { Element } from 'react';

type Props = {
  +location: Location;
};

const customAirpodsProducts = [
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.AIRPODS_WITH_CHARGING_CASE.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.AIRPODS_WITH_CHARGING_CASE.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.AIRPODS_WITH_WIRELESS_CHARGING_CASE.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.AIRPODS_WITH_WIRELESS_CHARGING_CASE.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.AIRPODS_PRO.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.AIRPODS_PRO.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.AIRPODS_MAX.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.AIRPODS_MAX.name,
  },
];

const customIphoneProducts = [
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_SE_PE.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_SE_PE.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_SE_CO.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_SE_CO.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_11_PE.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_11_PE.name,
  },
  // {
  //   path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_11_PRO_PE.routePath}`,
  //   name: routes.CUSTOM_PRODUCT.children.IPHONE_11_PRO_PE.name,
  // },
  // {
  //   path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_11_PRO_MAX_PE.routePath}`,
  //   name: routes.CUSTOM_PRODUCT.children.IPHONE_11_PRO_MAX_PE.name,
  // },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_11_CO.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_11_CO.name,
  },
  // {
  //   path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_11_PRO_CO.routePath}`,
  //   name: routes.CUSTOM_PRODUCT.children.IPHONE_11_PRO_CO.name,
  // },
  // {
  //   path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_11_PRO_MAX_CO.routePath}`,
  //   name: routes.CUSTOM_PRODUCT.children.IPHONE_11_PRO_MAX_CO.name,
  // },
  /*{
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_13_MINI.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_13_MINI.name,
  },*/
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_13.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_13.name,
  },
  /*{
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_13_PRO.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_13_PRO.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_13_PRO_MAX.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_13_PRO_MAX.name,
  },*/
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_14.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_14.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_14_PLUS.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_14_PLUS.name,
  },
  /*{
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_14_PRO.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_14_PRO.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_14_PRO_MAX.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_14_PRO_MAX.name,
  },*/
  /* IPHONE 15 */
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_15.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_15.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_15_PLUS.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_15_PLUS.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_15_PRO.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_15_PRO.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_15_PRO_MAX.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_15_PRO_MAX.name,
  },
  /* IPHONE 16 */
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_16.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_16.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_16_PLUS.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_16_PLUS.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_16_PRO.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_16_PRO.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_16_PRO_MAX.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_16_PRO_MAX.name,
  },
  /*{
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_12_MINI.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_12_MINI.name,
  },*/
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_12.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPHONE_12.name,
  },
  // {
  //   path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_12_PRO.routePath}`,
  //   name: routes.CUSTOM_PRODUCT.children.IPHONE_12_PRO.name,
  // },
  // {
  //   path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPHONE_12_PRO_MAX.routePath}`,
  //   name: routes.CUSTOM_PRODUCT.children.IPHONE_12_PRO_MAX.name,
  // },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPAD_PRO_11_INCH_WIFI.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPAD_PRO_11_INCH_WIFI.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPAD_PRO_11_INCH_WIFI_CELL.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPAD_PRO_11_INCH_WIFI_CELL.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPAD_PRO_12_9_INCH_WIFI.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPAD_PRO_12_9_INCH_WIFI.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPAD_PRO_12_9_INCH_WIFI_CELL.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPAD_PRO_12_9_INCH_WIFI_CELL.name,
  },

  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPAD_AIR_10_9_INCH_WIFI.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPAD_AIR_10_9_INCH_WIFI.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPAD_AIR_10_9_INCH_WIFI_CELL.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.IPAD_AIR_10_9_INCH_WIFI_CELL.name,
  },
];

const customAppleWatchProducts = [
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.APPLE_WATCH_6_SPACE_GRAY_ALUMINUM_CASE_SOLO_LOOP.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.APPLE_WATCH_6_SPACE_GRAY_ALUMINUM_CASE_SOLO_LOOP.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.APPLE_WATCH_6_SILVER_ALUMINUM_CASE_SOLO_LOOP.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.APPLE_WATCH_6_SILVER_ALUMINUM_CASE_SOLO_LOOP.name,
  },
];

const customSamsungProducts = [
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.SAMSUNG_GALAXY_S20_PE.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.SAMSUNG_GALAXY_S20_PE.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.SAMSUNG_GALAXY_S20_PLUS_PE.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.SAMSUNG_GALAXY_S20_PLUS_PE.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.SAMSUNG_GALAXY_S20_ULTRA_PE.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.SAMSUNG_GALAXY_S20_ULTRA_PE.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.SAMSUNG_GALAXY_S20_CO.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.SAMSUNG_GALAXY_S20_CO.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.SAMSUNG_GALAXY_S20_PLUS_CO.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.SAMSUNG_GALAXY_S20_PLUS_CO.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.SAMSUNG_GALAXY_S20_ULTRA_CO.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.SAMSUNG_GALAXY_S20_ULTRA_CO.name,
  },
];

const customProducts = [
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.PLAYSTATION_5.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.PLAYSTATION_5.name,
  },
  {
    path: `${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.PLAYSTATION_5_DIGITAL_EDITION.routePath}`,
    name: routes.CUSTOM_PRODUCT.children.PLAYSTATION_5_DIGITAL_EDITION.name,
  },
];

export default class CustomProducts extends Component<Props> {

  buildRoutes(): Element<Route>[] {
    let r = [
      <Route key="airpods-redirect" exact path="/custom-product/airpods">
        <Redirect to={`${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.AIRPODS_WITH_CHARGING_CASE.routePath}`} />
      </Route>,
      <Route key="ipad-pro-redirect" exact path="/custom-product/ipad-pro">
        <Redirect to={`${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPAD_PRO_11_INCH_WIFI.routePath}`} />
      </Route>,
      <Route key="ipad-air-redirect" exact path="/custom-product/ipad-air">
        <Redirect to={`${routes.CUSTOM_PRODUCT.routePath}${routes.CUSTOM_PRODUCT.children.IPAD_AIR_10_9_INCH_WIFI.routePath}`} />
      </Route>
    ];
    r = r.concat(
      customAirpodsProducts.map((product: { [key: string]: string }, index: number) => (
        <Route exact path={product.path}
               key={`airpods-${index}`}
               render={(props: any) => (
                 <Page name={product.name}>
                   <AirpodsContainer {...props}/>
                 </Page>
               )}
        />
      ))
    );
    
    r = r.concat(
      customIphoneProducts.map((product: { [key: string]: string }, index: number) => (
        <Route exact path={product.path}
               key={`iphone-${index}`}
               render={(props: any) => (
                 <Page name={product.name}>
                   <IphoneContainer {...props}/>
                 </Page>
               )}
        />
        )
      )
    );
    r = r.concat(
      customAppleWatchProducts.map((product: { [key: string]: string }, index: number) => (
        <Route exact path={product.path}
               key={`apple-watch-${index}`}
               render={(props: any) => (
                 <Page name={product.name}>
                   <AppleWatchContainer {...props}/>
                 </Page>
               )}
        />
        )
      )
    );
    r = r.concat(
      customSamsungProducts.map((product: { [key: string]: string }, index: number) => (
        <Route exact path={product.path}
               key={`samsung-${index}`}
               render={(props: any) => (
                 <Page name={product.name}>
                   <SamsungContainer {...props}/>
                 </Page>
               )}
        />
        )
      )
    );
    r = r.concat(
      customProducts.map((product: { [key: string]: string }, index: number) => (
        <Route exact path={product.path}
               key={`custom-products-${index}`}
               render={(props: any) => (
                 <Page name={product.name}>
                   <SamsungContainer {...props}/>
                 </Page>
               )}
        />
        )
      )
    );
    return r;
  }

  render() {
    return (
      <Fragment>
        <Helmet>
          <style type="text/css">{`
            #chat-bot-launcher-container {
              display: none!important;
            }            
          `}</style>
        </Helmet>
        <Switch>
          {this.buildRoutes()}
          <Route render={props => <Page name={routes.NOT_FOUND.name}><NotFound {...props}/></Page>}/>
        </Switch>
      </Fragment>);
  }
}

CustomProducts.propTypes = {
  location: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/custom-products/components/CustomProducts.jsx